export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
          {/* Left: text */}
          <div className="flex-1 max-w-xl">
            <p className="text-xs uppercase tracking-[0.2em] text-teal-600 font-semibold mb-4">
              Who We Are
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
              About<br />
              <span className="text-teal-600">KONUS d.o.o.</span>
            </h2>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-6">
              KONUS d.o.o. is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
            </p>
            <p className="text-gray-500 text-sm md:text-base leading-relaxed">
              We combine deep technical expertise with a passion for clean, intuitive design — delivering tools that keep your devices fast, private, and secure.
            </p>
          </div>

          {/* Right: visual */}
          <div className="flex-1 w-full max-w-lg">
            <div className="w-full h-[420px] md:h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/6f3cbb490176c6f429919fb2d45c85dd.jpg"
                alt="About KONUS d.o.o."
                className="w-full h-full object-cover object-top rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
